import React, { useMemo } from "react";
import DataTableBase from "../../../interfaccia/DataTableBase";
import CodiceVSVoceCliccabile from "../../../interfaccia/voci/CodiceVSVoceCliccabile";
import umanizzaDataSenzaSecondi from "../../../interfaccia/funzioniComuni/umanizzaDataSenzaSecondi";
import stilePulsanti from "../../../interfaccia/stilePulsanti";
import TastoRiprovaRiga from "./TastoRiprovaRiga";
import apiUrl from "../../../Apiurl";
import UserAvatarBadge from "../../../moda/UserAvatarBadge";

function ListaDashboard({
  setProductFunction,
  listaArticoli,
  utente,
  token,
  aggiorna,
  pagina,
  righePerPagina,
  totaleRighe,
  caricamento,
  ordinamentoCampo,
  ordinamentoDirezione,
  cambiaOrdinamento,
  cambiaPagina,
  cambiaRighePerPagina,
}) {
  const columns = useMemo(
    () => [
      {
        name: "Data inserimento",
        selector: (row) => row.dataInserimento || "",
        cell: (row) =>
          row.dataInserimento
            ? umanizzaDataSenzaSecondi(row.dataInserimento)
            : "",
        sortField: "dataInserimento",
        sortable: true,
        width: "150px",
      },
      {
        name: "VS",
        selector: (row) => row.codVS || "",
        cell: (row) =>
          row.codVS ? (
            <CodiceVSVoceCliccabile
              codiceVS={row.codVS}
              setProductFunction={setProductFunction}
              utente={utente}
              inGrassetto
              mostraIconaApertura
            />
          ) : (
            "X"
          ),
        sortField: "codVS",
        sortable: true,
        width: "130px",
      },
      {
        name: "Sito",
        selector: (row) => row.fonte || "VIG",
        cell: (row) => {
          const sito = row.fonte || "VIG";
          return (
            <span
              className={`b white br-pill ph2 pv1 ${
                sito === "BOT" ? "bg-red" : "bg-blue"
              }`}
            >
              {sito}
            </span>
          );
        },
        sortField: "fonte",
        sortable: true,
        width: "90px",
        center: true,
      },
      {
        name: "Tipo",
        selector: (row) => row.tipoSync || "",
        width: "220px",
        wrap: true,
      },
      {
        name: "Da sinc.",
        selector: (row) => (row.toSync === 1 ? "sì" : "no"),
        width: "90px",
      },
      {
        name: "Ok",
        selector: (row) => (row.success === 1 ? "✔️" : ""),
        width: "70px",
        center: true,
      },
      {
        name: "Err",
        selector: (row) => (row.error === 1 ? "❌" : ""),
        width: "70px",
        center: true,
      },
      {
        name: "Data operazione",
        selector: (row) => row.dataOperazione || "",
        cell: (row) =>
          row.dataOperazione
            ? umanizzaDataSenzaSecondi(row.dataOperazione)
            : "",
        sortField: "dataOperazione",
        sortable: true,
        width: "160px",
      },
      {
        name: "Response",
        selector: (row) => row.response || "",
        minWidth: "400px",
        wrap: true,
        grow: 3,
      },
      {
        name: "Utente",
        selector: (row) => row.utente || "",
        cell: (row) => <UserAvatarBadge username={row.utente} size={32} />,
        sortField: "utente",
        sortable: true,
        width: "100px",
        center: true,
      },
      {
        name: "Riprova",
        cell: (row) => (
          <TastoRiprovaRiga
            datiRiga={row}
            token={token}
            aggiorna={aggiorna}
            apiUrl={apiUrl}
            tastoRefreshAspetto={stilePulsanti.tastoRefreshAspetto}
          />
        ),
        width: "90px",
        center: true,
      },
    ],
    [aggiorna, setProductFunction, token, utente],
  );

  return (
    <div className="pa3">
      <DataTableBase
        columns={columns}
        data={listaArticoli}
        keyField="id"
        progressPending={caricamento}
        pagination
        paginationServer
        paginationTotalRows={totaleRighe}
        paginationPerPage={righePerPagina}
        paginationDefaultPage={pagina}
        paginationRowsPerPageOptions={[10, 20, 50, 100]}
        onChangePage={cambiaPagina}
        onChangeRowsPerPage={cambiaRighePerPagina}
        sortServer
        onSort={(column, direction) =>
          cambiaOrdinamento(column.sortField || "dataInserimento", direction)
        }
        defaultSortField={ordinamentoCampo}
        defaultSortAsc={ordinamentoDirezione === "asc"}
        highlightOnHover
        dense
        noDataComponent="Nessuna sincronizzazione trovata."
      />
    </div>
  );
}

export default ListaDashboard;
